import {Alert} from 'react-native';

import * as Device from 'expo-device';

import {logForCrashlytics} from 'src/Utils/fireUtils';
import {getReduxState} from './helpers';
import {mmkvStorage} from './mmkvStorage';
import {logCustomAnalyticsEvent} from './fireUtils';

const getBaseUrl = () => {
  const useLocalHost = getReduxState(['app_info', 'useLocalHost']);
  const actuallyUseBaseURL = __DEV__ && useLocalHost && !Device.isDevice;
  console.log({actuallyUseBaseURL, useLocalHost});
  return actuallyUseBaseURL
    ? `https://letsroam.local.com`
    : `https://api.letsroam.com`;
};

export const fetchWithParams = async (url, params) => {
  const requestId = 'request-' + Math.round(Math.random() * 100000000) + ':';
  logForCrashlytics(requestId + 'fetchWithParams fired in apiCalls');
  try {
    logForCrashlytics(requestId + 'the fetch url was ' + url);
    logForCrashlytics(requestId + 'the params were ' + JSON.stringify(params));
    const response = await fetch(url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(params),
    });

    if (response.status < 300) {
      return await response.json();
    } else {
      console.log({url});
      throw new Error(requestId + 'api fetch call failed', response);
    }
  } catch (error) {
    console.log(requestId + ' failed 2', {error});
  }
};

export const api_delete_user_or_group = async (params) => {
  const url = `${getBaseUrl()}/api/v1/delete_user_or_group`;

  console.log('delete_user_or_group', {url, params});
  try {
    const response = await fetchWithParams(url, params);
    // return Alert.alert('', JSON.stringify(response));
    console.log('delete response', {response});
    return response;
  } catch (error) {
    return {error};
  }
};

export const apiSendEventPushNotification = async (params) => {
  const url = `${getBaseUrl()}/api/v1/app_notifications/send_instant_push_notification`;

  console.log('apiSendEventPushNotification', {url, params});
  try {
    const response = await fetchWithParams(url, params);
    // return Alert.alert('', JSON.stringify(response));
    return response;
  } catch (error) {
    return {error};
  }
};

export const apiGetAllHunts = async () => {
  const url = `${getBaseUrl()}/api/v1/hunts/get_all_hunts?password=asf4fvadfv31das`;
  const token = 'ef4244b7-f677-406b-a603-ce933851a418';

  try {
    const result = await fetchWithParams(url, {token});

    return result;
  } catch (error) {
    return {error};
  }
};

export const apiTrackUserLogin = async ({user_id, latitude, longitude}) => {
  const url = `${getBaseUrl()}/api/v1/users/track_user_login`;
  const token = 'ef4244b7-f677-406b-a603-ce933851a418';
  const params = {user_id, token, latitude, longitude};

  try {
    const result = await fetchWithParams(url, params);

    return result;
  } catch (error) {
    return {error};
  }
};

export const apiFlagPhotos = async ({photoId, photoUrl}) => {
  const url = `${getBaseUrl()}/api/v1/flag_photo`;
  const params = {photoId, photoUrl};

  try {
    const result = await fetchWithParams(url, params);

    return result;
  } catch (error) {
    return {error};
  }
};

export const apiGetHuntThemes = async () => {
  const url = `${getBaseUrl()}/api/v1/app_themes`;
  const token = '7a21c094-2d88-4434-b2b5-bb8a6f3a71c3';
  const params = {token};

  try {
    const result = await fetchWithParams(url, params);

    return result;
  } catch (error) {
    return {error};
  }
};

export const apiLRrAppChallengeFeedback = async (params) => {
  const url = `${getBaseUrl()}/api/v1/app/community/leave_lr_app_challenge_feedback`;

  console.log('apiLRrAppChallengeFeedback', {params});
  try {
    const response = await fetchWithParams(url, params);
    // return Alert.alert('', JSON.stringify(response));
    // return response;
    if (response && response.response_title) {
      Alert.alert(response.response_title, response.response_body);
    }
  } catch (error) {
    return {error};
  }
};

export const fetchAddQuestionReview = async ({
  liked,
  groupInfo = {},
  questionData = {},
  userFeedback,
  lr_app_challenges_completions_id = 'none',
}) => {
  logForCrashlytics('fetchAddQuestionReview fired in apiCalls');
  const {db_id} = questionData;
  const {groupId, huntId} = groupInfo;

  const url =
    `${getBaseUrl()}/api/v1/hunts/add_question_review` +
    `?liked=${liked ? 'yes' : 'no'}` +
    `&auth_code=${groupId}` +
    `&question_id=${db_id}` +
    `&hunt_id=${huntId}` +
    `&r_role=${'none'}` +
    `&lr_app_challenges_completions_id=${lr_app_challenges_completions_id}` +
    `&additional_comments=${userFeedback || 'none'}`;

  try {
    const response = await fetch(url);

    if (response.status < 300) {
      const success = await response.json();
      return success;
    }
  } catch (error) {
    return {error};
  }
};

export const apiLeaveQuestionReview = async ({
  liked = '',
  questionId = '',
  appChallengeId = '',
  groupId = '',
  routeId = '',
  huntId = '',
  screen = '',
  userId = '',
  locationId = '',
  playTestState = 0,
  userFeedback = '',
  app_version = '',
}) => {
  const url =
    `${getBaseUrl()}/api/v1/hunts/add_question_review` +
    `?liked=${liked ? 'yes' : 'no'}` +
    `&auth_code=${groupId || ''}` +
    `&question_id=${questionId || ''}` +
    `&app_challenge_id=${appChallengeId || ''}` +
    `&location_id=${locationId || ''}` +
    `&hunt_id=${huntId || ''}` +
    `&route_id=${routeId || ''}` +
    `&user_id=${userId || ''}` +
    `&play_test_state=${playTestState}` +
    `&current_location=${locationId || ''}` +
    `&screen=${screen || ''}` +
    `&app_version=${app_version}` +
    `&r_role=${'none'}` +
    `&additional_comments=${userFeedback || 'none'}`;
  logForCrashlytics('apiLeaveQuestionReview fired in apiCalls' + url);

  logCustomAnalyticsEvent('leave_question_feedback', {
    userId,
    questionId,
    liked,
  });

  console.log({url});

  try {
    const response = await fetch(url);
    if (response.status < 300) {
      const result = await response.json();
      console.log('------------------------------------');
      console.log('------------------------------------');
      console.log('review response', result);
      console.log('------------------------------------');
      console.log('------------------------------------');
      return result;
    }
  } catch (error) {
    return {error};
  }
};

export const apiCESReview = async ({
  r_hunt = '',
  r_app = '',
  r_metric = '',
  groupId = '',
  userId = '',
  eventId = '',
  huntId = '',
  additionalComments = '',
  type = 'regular',
  additionalData = {},
  playTestState = 'false',
}) => {
  logForCrashlytics('apiCESReview fired in apiCalls');

  console.log({apiCESReview});

  logCustomAnalyticsEvent('leave_question_feedback', {
    userId,
    eventId,
    huntId,
  });

  const data = {
    user_id: userId,
    hunt_id: huntId,
    event_id: eventId,
    group_id: groupId,
    r_hunt: r_hunt,
    r_app: r_app,
    r_metric: r_metric,
    type: type,
    website_domain: 'app',
    play_test_state: playTestState,
    additional_comments: additionalComments || 'none',
    additional_data: JSON.stringify(additionalData),
  };

  const url = `${getBaseUrl()}/api/v1/hunts/add_hunt_review`;

  console.log({url, data});

  try {
    const response = await fetchWithParams(url, data);

    if (response.status < 300) {
      return await response.json();
    }
  } catch (error) {
    return {error};
  }
};

////////////////////////////////////////////////
/////////////////  voucher redemptions

export const apiCheckNamedVoucher = async (userId, voucherCode) => {
  logForCrashlytics('apiCheckNamedVoucher fired in apiCalls');

  const url = `${getBaseUrl()}/api/v1/app/vouchers/named_voucher`;
  const token = 'fd839e23-0ccc-4db4-bea2-ab92ba3f59fa';

  const params = {
    token,
    user_id: userId,
    voucher_code: voucherCode,
  };

  try {
    const result = await fetchWithParams(url, params);
    console.log({result});

    return result;
  } catch (error) {
    console.log(error);
  }
};

////////////////////////////////////////////////
/////////////////  community/daily challenges

export const getRecentTopPhotos = async () => {
  logForCrashlytics('getRecentTopPhotos fired in apiCalls');

  const url = `${getBaseUrl()}/api/v1/app/community/get_most_shared_photos`;
  const token = '1a20e933-4e14-478f-ae2f-0263711ac0c1';

  try {
    const result = await fetchWithParams(url, {token});

    return result && result.result;
  } catch (error) {
    console.log(error);
  }
};

export const getDailyChallenges = async (userId) => {
  logForCrashlytics('getDailyChallenges fired in apiCalls');

  const url = `${getBaseUrl()}/api/v1/app/community/get_daily_challenges`;
  const token = 'ccaa1d94-7878-4c57-b4af-8bfc5044d0d5';

  try {
    const result = await fetchWithParams(url, {
      token,
      user_id: userId,
    });

    return result && result.result;
  } catch (error) {
    console.log(error);
  }
};

export const apiLeaveChallengeFeedback = async ({challenge_id, liked}) => {
  logForCrashlytics('apiLeaveChallengeFeedback fired in apiCalls');

  const url = `${getBaseUrl()}/api/v1/app/allChallenges/leave_feedback`;
  const token = 'ccaa1d94-7878-4c57-b4af-8bfc5044d0d5';

  try {
    const result = await fetchWithParams(url, {
      token,
      challenge_id,
      liked,
    });

    return result;
  } catch (error) {
    console.log(error);
  }
};

export const apiFavoriteLocation = async (data) => {
  logForCrashlytics('apiLeaveChallengeFeedback fired in apiCalls');

  const url = `${getBaseUrl()}/api/v1/users/product/favorited`;
  const token = 'ccaa1d94-7878-4c57-b4af-8bfc5044d0d5';

  try {
    const result = await fetchWithParams(url, {
      ...data,
      token,
    });

    return result;
  } catch (error) {
    console.log(error);
  }
};

export const apiCheckAnyChallenge = async ({
  challenge_id,
  photo_url,
  shareUUID,
  token = '6af5a9e5-5bc5-45fb-a3e9-f2df6d48ae3b',
  user_id,
  group_id,
  location_id,
  google_vision_api_version = 1,
  record_completion = 1,
  share_UUID,
  points_earned,
  challenge_page = null,
}) => {
  const url = `${getBaseUrl()}/api/v1/app/community/check_any_lr_photo_challenge`;
  try {
    const result = await fetchWithParams(url, {
      challenge_id,
      photo_url,
      shareUUID,
      token,
      user_id,
      group_id,
      google_vision_api_version,
      record_completion,
      location_id,
      share_UUID,
      points_earned,
      challenge_page,
    });

    return result;
  } catch (error) {
    console.log(error);
  }
};

export const apiGetLocalGuide = async ({userId, latitude, longitude}) => {
  logForCrashlytics('apiGetLocalGuide fired in apiCalls');

  const url = `${getBaseUrl()}/api/v1/get_local_guide_info_all`;
  const token = '6af5a9e5-5bc5-45fb-a3e9-f2df6d48ae3b';

  try {
    const result = await fetchWithParams(url, {
      token,
      user_id: userId,
      lat: latitude,
      long: longitude,
    });

    return result;
  } catch (error) {
    console.log(error);
  }
};

export const apiMarkDailyChallengeCompleted = async (
  userId,
  scheduled_id = null,
  photo_url,
  shareUUID,
) => {
  logForCrashlytics('apiMarkDailyChallengeCompleted fired in apiCalls');

  logCustomAnalyticsEvent('daily_challenge_completed', {
    userId,
    scheduled_id,
    photo_url,
  });

  const url = `${getBaseUrl()}/api/v1/app/community/mark_daily_challenge_complete`;
  const token = '6af5a9e5-5bc5-45fb-a3e9-f2df6d48ae3b';

  try {
    const result = await fetchWithParams(url, {
      token,
      user_id: userId,
      scheduled_id,
      photo_url,
      shareUUID,
      google_vision_api_version: 1,
      autoPass: !Device.isDevice || __DEV__,
    });

    return result;
  } catch (error) {
    console.log(error);
  }
};

export const apiMarkSocialCompleted = async (userId, challengeType) => {
  logForCrashlytics('apiMarkSocialCompleted fired in apiCalls');

  const url = `${getBaseUrl()}/api/v1/app/community/mark_daily_challenge_complete`;
  const token = '6af5a9e5-5bc5-45fb-a3e9-f2df6d48ae3b';
  console.log('marking social challenge down', {userId, challengeType});
  try {
    const result = await fetchWithParams(url, {
      token,
      user_id: userId,
      challenge_type: challengeType,
    });

    console.log('the result was ', {result});

    return result;
  } catch (error) {
    console.log(error);
  }
};

export const apiUpdateUserInfo = async ({
  userId,
  gender,
  custom_photo_url,
  birthday,
  latitude,
  longitude,
  home_zip_code,
  contactPhone,
}) => {
  logForCrashlytics('apiUpdateUserInfo fired in apiCalls');

  const token = 'd889c33f-6b10-42ce-8ea6-414c981e2599';

  const params = {
    gender,
    custom_photo_url,
    birthday,
    home_zip_code,
    token,
    latitude,
    longitude,
    user_id: userId,
    contactPhone,
  };

  // Alert.alert(url, JSON.stringify(params));
  console.log({params});

  try {
    // Alert.alert(url, result)

    const userURL = `${getBaseUrl()}/api/v1/users/update_info`;

    const response = await fetchWithParams(userURL, params);

    return console.log('successly updated ' + userId, {response});
  } catch (error) {
    console.log(error);
  }
};

////////////////////////////////////////////////
/////////////////  Getting Extended User Data

export const apiUpdateUserBadges = async (userId, groupId) => {
  logForCrashlytics('apiUpdateUserBadges fired in apiCalls');
  console.log('!!!!!!!!!!!!!!!!!!!!! update badges !!!!!!!!!!!!!!!!!!!!');

  const url = `${getBaseUrl()}/api/v1/users/super_data`;
  console.log({url});
  const token = 'f68efd8c-852d-4bd5-885c-bec2b99f0c1a';
  userId = null;
  if (!userId) {
    userId = await mmkvStorage.getString('userId');
  }

  const params = {
    token,
    user_id: userId,
    group_id: groupId || null,
  };
  console.log({params});

  try {
    const result = await fetchWithParams(url, params);

    // console.log({result});
    return result;
  } catch (error) {
    console.log(error);
    if (__DEV__) {
      Alert.alert('Badges Api Error', error.message);
    }
  }
};

export const apiAdminEarnBadge = async ({user_id, badge_id}) => {
  const url = `${getBaseUrl()}/api/v1/admin_earn_badge`;

  const params = {
    user_id,
    badge_id,
  };

  try {
    const result = await fetchWithParams(url, params);
    console.log({result});
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const apiSendPostCard = async (address, postCardData, postCardURL) => {
  logForCrashlytics('apiSendPostCard fired in apiCalls');

  const url = `${getBaseUrl()}/api/v1/app_notifications/post_hunt_mailer/apiSendPostCard`;
  const token = 'f68efd8c-852d-4bd5-885c-besdfgsfdgfg';

  const params = {
    token,
    address,
    postCardData,
    postCardURL,
  };

  try {
    const result = await fetchWithParams(url, params);
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const apiRateLocationChallenge = async (challengeId, liked) => {
  logForCrashlytics('apiRateLocationChallenge fired in apiCalls');

  const url = `${getBaseUrl()}/api/v1/app/hunt/location_challenges/rate`;
  const token = 'a598f56b-2306-4f9a-aeec-3211ffb4519a';

  const question_id = challengeId?.substring?.(2);

  const params = {
    token,
    question_id,
    liked,
  };

  try {
    await fetchWithParams(url, params);
  } catch (error) {
    console.log(error);
  }
};

export const apiTrackUserTransaction = async ({
  type = '',
  user_id,
  usage_user_id,
  group_id = null,
  sch_voucher_code = null,
  coins = 0,
  tickets = null,
  theme = null,
  groupon_voucher_code = null,
  voucher_source = null,
}) => {
  const params = {
    type,
    user_id,
    usage_user_id,
    sch_voucher_code,
    group_id,
    coins,
    tickets,
    theme,
    groupon_voucher_code,
    voucher_source,
  };

  const url = `${getBaseUrl()}/store/api/app/track_app_transaction`;

  console.log('apiTrackUserTransaction', {params, url});

  try {
    const result = await fetchWithParams(url, params);
    console.log({result});
    return result;
  } catch (error) {
    console.log(error);
    return {};
  }
};

export const sendAppFAQFeedback = (feedback_type, entry_id) => {
  const url = `${getBaseUrl()}/api/v1/help_send_feedback?feedback=${feedback_type}&entry_id=${entry_id}`;
  console.log('sendAppFAQFeedback', {url});
  fetchWithParams(url);
};

export const getAppFaqData = async () => {
  const url = `${getBaseUrl()}/api/api_faqs_v1/get_app_faqs`;

  console.log('apiTrackUserTransaction', {url});

  try {
    const result = await fetchWithParams(url);
    console.log({result});
    return result?.Questions;
  } catch (error) {
    console.log(error);
    return {};
  }
};

export const schedulePushNotificationForUser = async ({
  title = '',
  body = '',
  topic = 'error',
}) => {
  const url = `${getBaseUrl()}/api/v1/app_notifications/send_instant_push_notification`;

  const data = {title, body, topic};

  console.log('send_instant_push_notification', {url, data});

  try {
    const result = await fetchWithParams(url, data);
    console.log({result});
    return result?.Questions;
  } catch (error) {
    console.log(error);
    return {};
  }
};

export const apiSetQuestion = async (data) => {
  const url = `${getBaseUrl()}/api/writers/set_question`;

  const params = {
    data: {
      ...data,
      long: data?.lng,
    },
  };

  console.log('the paramaters being sent are', params);

  try {
    const response = await fetchWithParams(url, params);
    console.log('the response is ', response);
    return response;
  } catch (error) {
    console.log('the lcoations could not be fetched', error);
  }
};

export const apiSignGuestBook = async (data) => {
  const url = `${getBaseUrl()}/api/writers/apiSignGuestBook`;

  const params = {
    ...data,
  };

  console.log('apiSignGuestBook', params);

  try {
    const response = await fetchWithParams(url, params);
    console.log('the response is ', response);
    return response;
  } catch (error) {
    console.log('the lcoations could not be fetched', error);
  }
};

export const apiGetLocalGuideDetails = async (data) => {
  const url = `${getBaseUrl()}/api/writers/apiGetLocalGuideDetails`;

  const params = {
    ...data,
  };

  console.log('apiGetLocalGuideDetails', params);

  try {
    const response = await fetchWithParams(url, params);
    console.log('the response is ', response);
    return response;
  } catch (error) {
    console.log('the lcoations could not be fetched', error);
  }
};

export const apiSetLocation = async (data) => {
  const url = `${getBaseUrl()}/api/writers/set_location`;

  delete data['location_id'];

  const params = {
    data: {
      ...data,
      long: data?.lng,
      lng: undefined,
      rank: undefined,
      editMode: undefined,
      question_order: undefined,
    },
  };
  delete params.data.question_count;
  delete params.data.regular_question_count;
  delete params.data.local_question_count;
  delete params.data.corporate_question_count;
  delete params.data.infoType;
  delete params.data.editType;

  console.log('the paramaters being sent are', params);

  try {
    const response = await fetchWithParams(url, params);
    console.log('the response is ', response);
    return response;
  } catch (error) {
    console.log('the lcoations could not be fetched', error);
  }
};

export const logPhoneCallAttempt = (
  source,
  user_phone_number,
  number_dialed,
) => {
  const userId = getReduxState(['user', 'userId']);
  const app_info = getReduxState(['app_info']);
  const url = `api/v1/lr_support_phone_call_requests`;
  const params = {
    source,
    user_phone_number,
    number_dialed,
    current_page: app_info?.currentPage,
    previous_page: app_info?.previousPage,
    previous_previous_page: app_info?.previousPreviousPage,
    user_id: userId,
  };
  console.log('sendAppFAQFeedback', {url, params});
  fetchWithParams(url, params);
};

export const apiChargeCard = async ({
  user_id,
  email,
  first_name,
  card_number,
  exp_month,
  exp_year,
  cvc,
  total,
  ticket_quantity,
  theme,
  isMembership,
  stripe_customer_id,
}) => {
  const params = {
    user_id,
    email,
    first_name,
    card_number,
    exp_month,
    exp_year,
    cvc,
    total,
    ticket_quantity,
    stripe_customer_id,
    theme,
    isMembership,
  };

  let url = `${getBaseUrl()}/store/api/app/create_charge_from_card`;

  if (__DEV__) {
    url += '?app_test=1';
  }

  console.log('charging card', {url, params});
  const chargeResult = await fetchWithParams(url, params);

  return chargeResult;
};
